import React, { useState, Fragment } from "react";
import clsx from 'clsx';
import { Link } from "react-router-dom"
import customStyles from "../../../assets/styles/customStyles";
import { Row, Col } from "antd";
import { salesMenus } from "../../../config/constant";
import { checkPermission } from '../../../helpers/utilities';
import { CustomerLeaderBoard, SalesPaymentStatement, SalesPriceDeviation, StaffSalesCollectionStatement, SalesLocation, CustomerAgedDues, InactiveCustomers } from "../../Shared/components/ReportEnquiry";

const Menus = (props) => {
    const [leaderBoardVisible, setLeaderBoardVisible] = useState(false);
    const [salesPaymentVisible, setSalesPaymentVisible] = useState(false);
    const [salesLocationVisible, setSalesLocationVisible] = useState(false);
    const [customerAgedDuesVisible, setCustomerAgedDuesVisible] = useState(false);
    const [inaciveCustomersVisible, setInaciveCustomersVisible] = useState(false);
    const [staffSalesCollectionVisible, setStaffSalesCollectionVisible] = useState(false);
    const [salesPriceDeviationVisible, setSalesPriceDeviationVisible] = useState(false);

    const [menuTitle, setMenuTitle] = useState('');
    const classes = customStyles();
    const { menuHeight } = props;

    const handleMenuOnClick = (name) => {
        setMenuTitle(name);
        if (name === 'Customer Invoice Report') {
            setLeaderBoardVisible(true);
        } else if (name === 'Sales & Payment- Statement') {
            setSalesPaymentVisible(true);
        } else if (name === 'Sales By Location') {
            setSalesLocationVisible(true);
        } else if (name === 'Customer Aged Dues') {
            setCustomerAgedDuesVisible(true);
        } else if (name === 'Inactive Customers') {
            setInaciveCustomersVisible(true);
        } else if (name === 'Staff sales and collection') {
            setStaffSalesCollectionVisible(true);
        } else if (name === 'Sales Price Deviation') {
            setSalesPriceDeviationVisible(true);
        }
    }

    return (
        <div className={clsx(classes.primaryPaper, classes.primaryMenu)} style={{ height: 'calc(100% - ' + menuHeight + 'px)', overflow: "auto" }}>
            <div style={{ height: '100%', overflow: "hidden" }}>
                <Row gutter={16}>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{salesMenus.sub[0].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {salesMenus.sub[0].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Sales') && <div key={i} className={clsx({ [classes.margin10t]: i !== 0 }, 'menuCheck')}>
                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{salesMenus.sub[1].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {salesMenus.sub[1].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Sales') && <div key={i} className={clsx({ [classes.margin10t]: i !== 0 }, 'menuCheck')}>
                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{salesMenus.sub[2].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {salesMenus.sub[2].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Sales') &&
                                            menus.menu !== 'Address' ?
                                            <Fragment key={i}>
                                                {
                                                    menus.onClick ? <div key={i} className={clsx({ [classes.margin10t]: i !== 0 }, 'menuCheck')}>
                                                        <Link to={menus.link} onClick={() => handleMenuOnClick(menus.menu)} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                    </div> : <div key={i} className={clsx({ [classes.margin10t]: i !== 0 }, 'menuCheck')}>
                                                        <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                    </div>
                                                }
                                            </Fragment> : ''
                                    )
                                })}
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{salesMenus.sub[3].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {salesMenus.sub[3].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Sales') && menus.menu !== 'Address' ?
                                            <div key={i} className={clsx({ [classes.margin10t]: i !== 0 }, 'menuCheck')}>
                                                <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                            </div> : ''
                                    )
                                })
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
                <CustomerLeaderBoard
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={leaderBoardVisible}
                    onLeaderBoardVisible={(v) => setLeaderBoardVisible(v)} />
                <SalesLocation
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={salesLocationVisible}
                    onSalesLocationVisible={(v) => setSalesLocationVisible(v)} />
                <SalesPaymentStatement
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={salesPaymentVisible}
                    onSalesPaymentVisible={(v) => setSalesPaymentVisible(v)} />
                <CustomerAgedDues
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={customerAgedDuesVisible}
                    onCustomerAgedDuesVisible={(v) => setCustomerAgedDuesVisible(v)} />
                <InactiveCustomers
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={inaciveCustomersVisible}
                    onInactiveCustomersVisible={(v) => setInaciveCustomersVisible(v)} />
                <StaffSalesCollectionStatement
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={staffSalesCollectionVisible}
                    onStaffSalesCollectionVisible={(v) => setStaffSalesCollectionVisible(v)} />
                <StaffSalesCollectionStatement
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={staffSalesCollectionVisible}
                    onStaffSalesCollectionVisible={(v) => setStaffSalesCollectionVisible(v)} />
                <SalesPriceDeviation
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={salesPriceDeviationVisible}
                    onSalesPriceDeviationVisible={(v) => setSalesPriceDeviationVisible(v)} />
            </div>
        </div>
    )
}

export default Menus